// OGC-531 Creatives Manager v19 stroke icons (prototype app.js icon paths).
const PATHS = {
  edit: <path d="m15 4 5 5M4 20l5-1L20 8a3.5 3.5 0 0 0-5-5L4 14Z" />,
  play: <path d="m8 5 11 7-11 7Z" />,
  archive: <><rect x="3" y="3" width="18" height="4" rx="1" /><path d="M5 7v14h14V7M10 11h4" /></>,
  unarchive: <path d="M5 9v12h14V9M9 5l3-3 3 3M12 2v12M3 9h18" />,
  trash: <path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7" />,
  back: <path d="m12 5-7 7 7 7M5 12h14" />,
  more: <><circle cx="5" cy="12" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /></>,
  grip: <><circle cx="9" cy="5" r="1" /><circle cx="15" cy="5" r="1" /><circle cx="9" cy="12" r="1" /><circle cx="15" cy="12" r="1" /><circle cx="9" cy="19" r="1" /><circle cx="15" cy="19" r="1" /></>,
  refresh: <path d="M20 7a9 9 0 1 0 1 8M20 3v5h-5" />,
};

export function CmIcon({ name, size = 17 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {PATHS[name] || null}
    </svg>
  );
}
